import { PropsWithChildren } from 'react';
import { Layout } from 'antd';
import clsx from 'clsx';

interface IContainerProps {
  className?: string;
  noIndents?: boolean;
  scrollable?: boolean;
  isFullHeight?: boolean;
}

export const Container = ({
  children,
  className,
  noIndents,
  scrollable,
  isFullHeight,
}: PropsWithChildren<IContainerProps>) => (
  <Layout
    className={
      clsx(
        className,
        'bg-white',
        isFullHeight && 'h-full',
        !noIndents && 'py-[10px] px-[10px]',
        scrollable && 'overflow-auto h-[calc(100%-1px)]',
      )
    }
  >
    {children}
  </Layout>
);
